
/* Todos los scripts del sitio son sincronos (sin async/defer), asi que en
   DOMContentLoaded el puente ya corrio y ya inyecto sus reglas. */
document.addEventListener("DOMContentLoaded", function(){
  document.documentElement.classList.add("pc-listo");
});
